export default {
  button: {
    en: 'Search!',
    ar: 'ودني للفروع'
  }
};
